import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=4c4fed2c"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=4c4fed2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports